'use client';

import { ColumnCardGrid } from '@/components/ui/data-display/cards/ColumnCardGrid';
import { GridCol } from '@/components/ui/layouts/grids/GridCol';

import { gridCol } from '@mage-ui/styled-system/recipes';

export const CardItem = ({ data }) => {
  const imagePrefix = '';

  return (
    <GridCol className={gridCol({ colSpanM: '6', colSpanL: '3' })}>
      <ColumnCardGrid
        data={{
          img_card: data?.fields?.img_card
            ? imagePrefix + data?.fields?.img_card
            : undefined,
          title: data?.fields?.title || null,
          description: data?.fields?.description || data?.fields?.intro || null,
          cta_text: data?.fields?.cta_text || null,
          cta_slug: data?.fields?.cta_slug || null,
          alt_img: data?.fields?.alt_img || null,
        }}
      />
    </GridCol>
  );
};
